import { useEffect, useRef } from "react";
import { Grid, Box, Typography, Chip } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleFontPreview } from "../helpers";

const tempCategories = [
  { name: "HOME", id: 1 },
  { name: "GUIDE", id: 2 },
  { name: "ON DEMAND", id: 3 },
  { name: "DVR", id: 4 },
  { name: "VIDEO/PLAYER", id: 5 },
  { name: "SEARCH", id: 6 },
  { name: "OTHER", id: 7 },
];

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  technology: string | undefined;
  handleBtnPosition: (category: any) => void;
  ClickedCat: any;
  generalPreviewRef?: any;
}

const FirstPagePreview = ({
  product,
  previewAgent,
  branding,
  technology,
  handleBtnPosition,
  ClickedCat,
  generalPreviewRef,
}: IProps) => {
  return (
    <Box
      ref={generalPreviewRef}
      sx={{
        mt: previewAgent ? "65px" : "20px",
        mb: 2,
        p: previewAgent ? "60px 20px 10px 30px" : "20px",
        borderRadius:
          technology !== "rokuTv"
            ? branding?.[brandingConstants.inputFieldBorderRadius]
            : "0px",

        border: `3px solid ${
          branding?.[brandingConstants.inputFieldBorderColor]
        }`,
      }}
    >
      <Grid container>
        <Grid xs={12} sx={{ mb: 2 }}>
          <Box>
            <Typography
              sx={{
                mb: 2,
                pb: 2,
                color: branding?.[brandingConstants.inputLabelColor],
                fontSize: handleFontPreview(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                ),
                fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
                fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
                fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
                display: "-webkit-box",
                "-webkit-line-clamp": "2",
                "-webkit-box-orient": "vertical",
                textOverflow: "ellipsis",
                overflow: "hidden",
                maxHeight: "3.2em",
                lineHeight: "1.5em",
              }}
            >
              {product?.feedbackSettings?.categoryHeading}
            </Typography>
            <Box
              display="flex"
              flexWrap="wrap"
              columnGap={previewAgent ? "16px" : "5px"}
              rowGap={previewAgent ? "30px" : "5px"}
            >
              {product?.feedbackSettings?.categories?.length > 0 ? (
                <>
                  {product?.feedbackSettings?.categories.map(
                    (category: any) => (
                      <>
                        <Chip
                          className={`tv-feedback-chips ${
                            ClickedCat == category.name ? "selected" : ""
                          }`}
                          key={category.id}
                          onClick={() => handleBtnPosition(category.name)}
                          label={category.name}
                          variant={
                            ClickedCat == category.name ? "filled" : "outlined"
                          }
                          sx={{
                            "& .MuiChip-label": {
                              paddingLeft: "0px",
                              paddingRight: "0px",
                            },
                            flexBasis: "32%",
                            padding: previewAgent ? "25px 5px" : "5px 10px",
                            fontSize: handleFontPreview(
                              branding?.[brandingConstants.cardTitleFontSize],
                              previewAgent
                            ),
                            fontFamily:
                              branding?.[brandingConstants.cardTitleFontFamily],
                            fontStyle:
                              branding?.[brandingConstants.cardTitleFontStyle],
                            fontWeight: `${
                              branding?.[brandingConstants.cardTitleFontWeight]
                            }!important`,
                            background:
                              branding?.[brandingConstants.cardMainBGColor],

                            color:
                              branding?.[brandingConstants?.cardTitleTextColor],

                            border: `3px solid ${
                              branding?.[brandingConstants.cardBorderColor]
                            }`,

                            borderRadius:
                              technology !== "rokuTv"
                                ? branding?.[brandingConstants.cardBorderRadius]
                                : "0px",
                            "&::before": {
                              background:
                                branding?.[brandingConstants.cardBorderColor],
                            },
                            "&:hover": {
                              background: `${
                                branding?.[brandingConstants.cardMainBGColor]
                              }!important`,
                              opacity: "0.7",
                            },
                            "&.selected": {
                              borderColor:
                                branding?.[brandingConstants.cardBorderColor],
                            },
                          }}
                        />
                      </>
                    )
                  )}
                </>
              ) : (
                <>
                  {tempCategories.map((category: any) => (
                    <>
                      <Chip
                        className={`tv-feedback-chips ${
                          ClickedCat == category.name ? "selected" : ""
                        }`}
                        key={category.id}
                        onClick={() => handleBtnPosition(category.name)}
                        label={category.name}
                        variant={
                          ClickedCat == category.name ? "filled" : "outlined"
                        }
                        sx={{
                          "& .MuiChip-label": {
                            paddingLeft: "0px!important",
                            paddingRight: "0px!important",
                          },
                          flexBasis: "32%",
                          padding: previewAgent ? "25px 5px" : "5px 10px",
                          fontSize: handleFontPreview(
                            branding?.[brandingConstants.cardTitleFontSize],
                            previewAgent
                          ),
                          fontFamily:
                            branding?.[brandingConstants.cardTitleFontFamily],
                          fontStyle:
                            branding?.[brandingConstants.cardTitleFontStyle],
                          fontWeight: `${
                            branding?.[brandingConstants.cardTitleFontWeight]
                          }!important`,
                          background:
                            branding?.[brandingConstants.cardMainBGColor],

                          color:
                            branding?.[brandingConstants?.cardTitleTextColor],

                          border: `3px solid ${
                            branding?.[brandingConstants.cardBorderColor]
                          }`,

                          borderRadius:
                            technology !== "rokuTv"
                              ? branding?.[brandingConstants.cardBorderRadius]
                              : "0px",
                          "&::before": {
                            background:
                              branding?.[brandingConstants.cardBorderColor],
                          },
                          "&:hover": {
                            background: `${
                              branding?.[brandingConstants.cardMainBGColor]
                            }!important`,
                            opacity: "0.7",
                          },
                          "&.selected": {
                            borderColor:
                              branding?.[brandingConstants.cardBorderColor],
                          },
                        }}
                      />
                    </>
                  ))}
                </>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FirstPagePreview;
